import React, { Component } from 'react';
import styled from 'styled-components';
import { DragDropContext } from 'react-beautiful-dnd'
import 'array.prototype.move'; 

import { SLICES, STAGE, INPUT, OUTPUT } from './parts/stages'
import PartPicker from './components/PartPicker';
import BuildArea from './components/BuildArea';
import ResultsArea from './components/ResultsArea';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 1em;
  height: 90vh;
`



class App extends Component {

  state={stages:[], input:null, output: null}

  removeSlice = (idx) => () => {
    const { stages } = this.state
    this.setState({ stages: [...stages.slice(0, idx), ...stages.slice(idx + 1)] })
  }

  onDragEnd = (result, provided) => {
    const STAGES = SLICES.filter(s => s.type === STAGE)
    const INPUTS = SLICES.filter(s => s.type === INPUT)
    const OUTPUTS = SLICES.filter(s => s.type === OUTPUT)
    const {source, destination} = result;
    if(!destination) {
      return;
    }
    if(destination.droppableId === 'build-area') {
      switch (source.droppableId) {
        case "stages-list":
          const {stages} = this.state;
          const newStage = STAGES.find((stage) => stage.name === result.draggableId.slice(11))
          if(!newStage) {
            console.error(`No new stage ${result.draggableId.slice(11)}`)
            return
          }
          this.setState({stages: [...stages, newStage]})
          break;
        case "outputs-list":
          const output = OUTPUTS.find((out) => out.name === result.draggableId.slice(12))
          
          this.setState({output: output})
          break;
        case "inputs-list":
          const input = INPUTS.find((input) => input.name === result.draggableId.slice(11))
          this.setState({input: input})
          break;
        case "build-area":
          if(source.droppableId === destination.droppableId){
            const {stages} = this.state
            const newStages = Array.from(stages).move(source.index, destination.index)
            this.setState({stages:newStages})
          }
          break;
        default:
          console.error("You dropped something I don't know how to handle" + source.droppableId)
          break;
      }
    }
  }

  render() {

    // const errors = check(this.state, Rules)

    const stages = SLICES.filter(s => s.type === STAGE)
    const inputs = SLICES.filter(s => s.type === INPUT)
    const outputs = SLICES.filter(s => s.type === OUTPUT)
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Container className="App">
          <PartPicker stages={stages} outputs={outputs} inputs={inputs}/>
          <BuildArea {...this.state} removeStage={this.removeSlice}/>
          <ResultsArea {...this.state}/> 
        </Container>
      </DragDropContext>
    );
  }
}

export default App;
